import {
  useAppDispatch,
  useAppSelector
} from '@verzekeringapp-mono/shared/src/hooks/state'
import usePolicies from '@verzekeringapp-mono/shared/src/hooks/use_policies'
import {
  getPolicies,
  getSelectedPolicy
} from '@verzekeringapp-mono/shared/src/state/selectors/policies'
import { setSelectedPolicyNumber } from '@verzekeringapp-mono/shared/src/state/slices/policies_slice'
import { determinePolicyDistinctionLabel } from '@verzekeringapp-mono/shared/src/utils/policy_utils'
import React, { useEffect, useMemo } from 'react'
import { useForm } from 'react-hook-form'

const PolicySelector = () => {
  const { updatePolicyOnPolicyNumber } = usePolicies()
  const dispatch = useAppDispatch()
  const policies = useAppSelector(getPolicies)
  const selectedPolicy = useAppSelector(getSelectedPolicy)
  const {
    register,
    watch,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {
      policy: selectedPolicy?.policyNumber
    }
  })

  const claimablePolicies = useMemo(() => policies.filter(policy => policy.isAllowedToReportClaim && policy.status !== 'Toekomstig'), [policies])

  const policyNumber = watch('policy')
  const [oldPolicyNumber, setOldPolicyNumber] = React.useState('')

  useEffect(() => {
    if (selectedPolicy && selectedPolicy.policyNumber !== oldPolicyNumber) {
      reset({ policy: selectedPolicy?.policyNumber })

      updatePolicyOnPolicyNumber(selectedPolicy.policyNumber)
      setOldPolicyNumber(selectedPolicy.policyNumber)
    }
  }, [selectedPolicy?.policyNumber, reset])

  useEffect(() => {
    if (policyNumber && policyNumber !== oldPolicyNumber) {
      dispatch(setSelectedPolicyNumber(policyNumber))
    }
  }, [policyNumber])

  return (
    <div className='mb-6 flex flex-col flex-1'>
      <label
        htmlFor='policy'
        className='mb-2 w-full font-medium text-text-primary'
      >
        Op welke polis wil je schade melden?
      </label>

      <div className='w-full flex-1'>
        <select
          id='policy'
          {...register('policy', { required: true })}
          className={`h-full w-full rounded-md border bg-surface-input p-4 text-text-primary shadow-sm focus:outline-none ${
            errors.policy
              ? 'border-border-danger focus:border-border-danger'
              : 'border-border-default focus:border-border-focus'
          }`}
        >
          {claimablePolicies.map(policy => (
            <option
              key={policy.id}
              selected={selectedPolicy?.policyNumber === policy.policyNumber}
              value={policy.policyNumber}
            >
              {policy.productName}

              &nbsp; ({determinePolicyDistinctionLabel(policy)})
            </option>
          ))}
        </select>

        {errors.policy && (
          <span className='mt-1 block text-sm text-status-danger-foreground'>
            Dit veld is verplicht.
          </span>
        )}
      </div>
    </div>
  )
}

export default PolicySelector
